import { Component, Input, OnInit } from '@angular/core';
import { OktaAuthService } from 'src/app/app.service';
import { constants } from 'src/app/shared/constants';
import { SessionStorageItem } from 'src/app/shared/model/shared-items';
import { ContextService } from 'src/app/shared/services/context-service';
import { ItsmService } from 'src/app/shared/services/itsm.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-services-navbar',
  templateUrl: './services-navbar.component.html',
  styleUrls: ['./services-navbar.component.scss'],
})
export class ServicesNavbarComponent implements OnInit {

  navBarTheme = '';
  nucleusUrl = '';
  portalSatisfactionSurveyUrl = constants.portalSatisfactionSurveyUrl;
  mySecurityReportUrl = 'https://my-security-reports.engsec/auth_okta';

  constructor(
    public itsmService: ItsmService,
    public contextService: ContextService,
    public oktaAuthService: OktaAuthService
    ) {}

  ngOnInit(): void {
    // initialize access and url to nucleus
    this.initManagedVulnIntUrl();

    this.navBarTheme = this.contextService.navBarTheme;
  }

  /**
   * check the access to managed vulnerability intelligence services
   */
  public initManagedVulnIntUrl() {
    // get vulnerabilities only if tenant selected
    if(this.oktaAuthService.selectedTenant) {
      let itsmServices = JSON.parse(sessionStorage.getItem(SessionStorageItem.itsmServices));
      if (!itsmServices) {
        this.itsmService.getCachedServices().then((res) => {
          itsmServices = res;
          this.checkManagedVulnIntAccess(itsmServices);
        });
      } else {
        this.checkManagedVulnIntAccess(itsmServices);
      }
    };
  }

  /**
   * check all itsmservices to displayed Managed Vulnerability Inteligence access in services tab
   */
  public checkManagedVulnIntAccess(itsmServices) {
    //@ts-ignore
    const NUCLEUS_IDS = environment.nucleusIds;
    // filter on active status and service name
    const filt = itsmServices.filter(
      (itsm) => itsm.status === constants.nucleusStatus && itsm.serviceName === constants.nucleusServiceName
    );
    filt.forEach((service) => {
      NUCLEUS_IDS.forEach((nucleusId) => {
        // only display for specific service center id
        if (nucleusId.id === service.serviceCenter) {
          this.nucleusUrl = nucleusId.url;
        }
      });
    });
  }

  public clearAssetsRetention() {
    sessionStorage.removeItem(SessionStorageItem.assetRetention);
  }
}
